var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hub-header"},[_c('HubOrganization',{attrs:{"image":_vm.organization.image,"title":_vm.organization.title,"subtitle":_vm.organization.subtitle,"href":_vm.organization.href,"is-mark":_vm.organization.mark}}),_c('div',{staticClass:"hub-header__slot"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }